export const initCookieSettingsLink = () => {
    document.dispatchEvent(new Event('initCookieSettingsLink'));
};
